module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/kamila-bandurska-45d041dfa05e3341d89d4132ab46067a.png";